import FormMediaFile from 'components/common/forms/FormMediaFile';
import FormAutoHeightTextarea from 'components/common/forms/FormAutoHeightTextarea';
import styles from 'styles/pages/chart/DslrChart.module.scss';
import { TAttachmentFiles } from 'types/chart/dslrChart';
import { DslrChartFields } from 'constants/chart/dslrChart';

type TProps = {
  formMediaFileRefs: React.MutableRefObject<
    Array<{ resetFile: () => void } | null>
  >;
  attachmentFiles: TAttachmentFiles;
  deleteFileIdList: number[];
  setDeleteFileIdList: React.Dispatch<React.SetStateAction<number[]>>;
  changeFile: (index: number, file: File[]) => void;
  isRegister: boolean;
  isReadOnly: boolean;
};

const DslrChart = ({
  formMediaFileRefs,
  attachmentFiles,
  deleteFileIdList,
  setDeleteFileIdList,
  changeFile,
  isRegister,
  isReadOnly,
}: TProps) => {
  return (
    <>
      <div className="flex justify_center">
        <dl className={styles.chart_container_top}>
          <dt className={styles.title_wrapper}>상악교합면</dt>
          <dd className={styles.photo_wrapper}>
            <FormMediaFile
              ref={(el) => {
                formMediaFileRefs.current[0] = el as {
                  resetFile: () => void;
                } | null;
              }}
              files={attachmentFiles[0] ? [attachmentFiles[0]] : []}
              inputId="dslrImages1"
              readOnly={!isRegister || isReadOnly}
              onDelete={(index) =>
                setDeleteFileIdList([...deleteFileIdList, index])
              }
              onChange={(files) => changeFile(0, files)}
            />
          </dd>
        </dl>
      </div>
      <div className="flex justify_center">
        <dl className={styles.chart_container_left}>
          <dt className={styles.title_wrapper}>상·하악교합관계(오른쪽)</dt>
          <dd className={styles.photo_wrapper}>
            <FormMediaFile
              ref={(el) => {
                formMediaFileRefs.current[1] = el as {
                  resetFile: () => void;
                } | null;
              }}
              files={attachmentFiles[1] ? [attachmentFiles[1]] : []}
              inputId="dslrImages2"
              readOnly={!isRegister || isReadOnly}
              onDelete={(index) =>
                setDeleteFileIdList([...deleteFileIdList, index])
              }
              onChange={(files) => changeFile(1, files)}
            />
          </dd>
        </dl>
        <dl className={styles.chart_container}>
          <dt className={styles.title_wrapper}>상·하악교합관계(전치부)</dt>
          <dd className={styles.photo_wrapper}>
            <FormMediaFile
              ref={(el) => {
                formMediaFileRefs.current[2] = el as {
                  resetFile: () => void;
                } | null;
              }}
              files={attachmentFiles[2] ? [attachmentFiles[2]] : []}
              inputId="dslrImages3"
              readOnly={!isRegister || isReadOnly}
              onDelete={(index) =>
                setDeleteFileIdList([...deleteFileIdList, index])
              }
              onChange={(files) => changeFile(2, files)}
            />
          </dd>
        </dl>
        <dl className={styles.chart_container_right}>
          <dt className={styles.title_wrapper}>상·하악교합관계(왼쪽)</dt>
          <dd className={styles.photo_wrapper}>
            <FormMediaFile
              ref={(el) => {
                formMediaFileRefs.current[3] = el as {
                  resetFile: () => void;
                } | null;
              }}
              files={attachmentFiles[3] ? [attachmentFiles[3]] : []}
              inputId="dslrImages4"
              readOnly={!isRegister || isReadOnly}
              onDelete={(index) =>
                setDeleteFileIdList([...deleteFileIdList, index])
              }
              onChange={(files) => changeFile(3, files)}
            />
          </dd>
        </dl>
      </div>
      <div className="flex justify_center">
        <dl className={styles.chart_container_bottom}>
          <dt className={styles.title_wrapper}>하악교합면</dt>
          <dd className={styles.photo_wrapper}>
            <FormMediaFile
              ref={(el) => {
                formMediaFileRefs.current[4] = el as {
                  resetFile: () => void;
                } | null;
              }}
              files={attachmentFiles[4] ? [attachmentFiles[4]] : []}
              inputId="dslrImages5"
              readOnly={!isRegister || isReadOnly}
              onDelete={(index) =>
                setDeleteFileIdList([...deleteFileIdList, index])
              }
              onChange={(files) => changeFile(4, files)}
            />
          </dd>
        </dl>
      </div>

      <div className="flex justify_center w100 mt48">
        <dl className={styles.text_container_left}>
          <dt className={styles.title_wrapper}>구강 내 상태 기록</dt>
          <dd className={styles.textarea_wrapper}>
            <FormAutoHeightTextarea
              name={DslrChartFields.oralConditionRecord}
              readOnly={!isRegister || isReadOnly}
              placeholder="구강 내 상태 기록을 입력해 주세요."
              textareaStyle={{
                width: '100%',
                minHeight: '240px',
                padding: '12px 16px',
                border: 'none',
                marginLeft: '0',
              }}
            />
          </dd>
        </dl>
        <dl className={styles.text_container_right}>
          <dt className={styles.title_wrapper}>실책 및 보상법</dt>
          <dd className={styles.textarea_wrapper}>
            <FormAutoHeightTextarea
              name={DslrChartFields.mistakesAndCompensation}
              readOnly={!isRegister || isReadOnly}
              placeholder="실책 및 보상법을 입력해 주세요."
              textareaStyle={{
                width: '100%',
                minHeight: '240px',
                padding: '12px 16px',
                border: 'none',
                marginLeft: '0',
              }}
            />
          </dd>
        </dl>
      </div>
    </>
  );
};

export default DslrChart;
